export default __webpack_public_path__ + "static/media/moma-origin.8d1faac6.png";